import React from 'react';
import connectToStores from 'fluxible-addons-react/connectToStores';
import {navigateAction} from 'fluxible-router';
import shallowCompare from '../../lib/shallowCompare';
import CustomerStore from '../../stores/CustomerStore';
import AuthForm from '../../components/AuthForm';
import Helmet from 'react-helmet';
import styles from './index.sass';

class AuthContainer extends React.Component {
  static contextTypes = {
    executeAction: React.PropTypes.func
  };

  shouldComponentUpdate(nextProps, nextState) {
    return shallowCompare(this, nextProps, nextState);
  }

  getHelmetProps() {
    let { store, currentRoute } = this.props;
    let title;
    switch(currentRoute.name) {
      case 'setPassword':
        title = 'Set password';
        break;
      case 'activateAccount':
        title = 'Activate account';
        break;
      default:
        title = 'Sign in / Sign up';
        break;
    }
    if(store) {
      title += ` – ${store.name}`;
    }
    return {
      title: title,
      meta: []
    };
  }

  handleOnSignIn() {
    this.redirectToSearch();
  }

  handleOnSetPassword() {
    this.context.executeAction(navigateAction, {routeName: 'settings'});
  }

  handleOnPasswordResetRequested() {
    this.redirectToSearch();
  }

  redirectToSearch() {
    this.context.executeAction(navigateAction, {url: this.props.store ? this.props.store.root_path : `/`});
  }

  render() {
    let { currentRoute, customer, requestStatus, error } = this.props;
    let authFormProps = {
      mode: (currentRoute.name === 'setPassword' || currentRoute.name === 'activateAccount') ? 'SetPassword' : null,
      customer: customer,
      requestStatus: requestStatus,
      error: error,
      onSignIn: this.handleOnSignIn.bind(this),
      onPasswordResetRequested: this.handleOnPasswordResetRequested.bind(this),
      onSetPassword: this.handleOnSetPassword.bind(this)
    };

    return (
      <section className={styles.container}>
        <Helmet {...this.getHelmetProps()} />
        <AuthForm {...authFormProps} />
      </section>
    );
  }
}

AuthContainer = connectToStores(AuthContainer, [CustomerStore], (context, props) => {
  let customerStore = context.getStore(CustomerStore);
  return {
    customer: customerStore.getCurrentCustomer(),
    requestStatus: customerStore.getCurrentRequestStatus(),
    error: customerStore.getCurrentError()
  };
});

export default AuthContainer;



// WEBPACK FOOTER //
// banquet/containers/AuthContainer/index.js